import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t border-[#2a2a2a] mt-24">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-[15px] text-[#c2c2c2] leading-relaxed">
                <div>
                    <div className="font-display text-lg text-white mb-2">
                        SmartNote2Self License Risk Scan
                    </div>
                    <p className="leading-relaxed">
                        An independent Microsoft licensing assessment tool. Advisory
                        only — not legal, compliance, or contractual interpretation.
                    </p>
                </div>
                <div>
                    <div className="overline mb-3">Independence</div>
                    <ul className="space-y-1">
                        <li>We do not represent Microsoft.</li>
                        <li>We do not represent any reseller.</li>
                        <li>We do not recommend vendors.</li>
                    </ul>
                </div>
                <div>
                    <div className="overline mb-3">Your Privacy (GDPR)</div>
                    <ul className="space-y-1">
                        <li>Right to access · Right to rectification</li>
                        <li>Right to erasure · Right to portability</li>
                        <li>
                            Delete your data anytime from your dashboard.
                        </li>
                    </ul>
                    <div className="mt-4 flex gap-3">
                        <Link
                            to="/privacy"
                            className="text-white hover:text-[#00A896] underline-offset-4 hover:underline"
                            data-testid="footer-privacy-link"
                        >
                            Privacy Notice
                        </Link>
                        <span className="text-[#9a9a9a]">·</span>
                        <Link
                            to="/terms"
                            className="text-white hover:text-[#00A896] underline-offset-4 hover:underline"
                            data-testid="footer-terms-link"
                        >
                            Terms of Use
                        </Link>
                    </div>
                </div>
            </div>
            <div className="border-t border-[#2a2a2a]">
                <div
                    className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 text-[13px] tracking-[0.1em] uppercase font-semibold grid grid-cols-1 md:grid-cols-3 gap-3 items-center"
                    data-testid="footer-bottom-row"
                >
                    <div className="text-[#d4d4d4] md:text-left text-center" data-testid="footer-copyright">
                        © {new Date().getFullYear()} SmartNote2Self
                    </div>
                    <div
                        className="text-[#2ec5b6] text-center normal-case tracking-normal text-[12px] font-normal"
                        data-testid="footer-independence-note"
                    >
                        Advisory · Not Microsoft · Not a reseller
                    </div>
                    <div className="flex gap-4 md:justify-end justify-center">
                        <Link
                            to="/privacy"
                            className="text-white hover:text-[#2ec5b6] transition-colors"
                            data-testid="footer-privacy-link-bottom"
                        >
                            Privacy
                        </Link>
                        <span className="text-[#3a3a3a]" aria-hidden="true">·</span>
                        <Link
                            to="/terms"
                            className="text-white hover:text-[#2ec5b6] transition-colors"
                            data-testid="footer-terms-link-bottom"
                        >
                            Terms
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
